import type { ReactNode } from 'react';
import { startTransition, useMemo } from 'react';

import createEmotionCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { ODTeamBoundary } from 'platform/ODTeamBoundary';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';
import 'preloadQueries';

function ClientCacheProvider({ children }: { children: ReactNode }) {
  const cache = useMemo(() => createEmotionCache({ key: 'css' }), []);

  return <CacheProvider value={cache}>{children}</CacheProvider>;
}

const hydrate = () => {
  startTransition(() => {
    hydrateRoot(
      document,
      <ODTeamBoundary team="seller">
        <ClientCacheProvider>
          <HydratedRouter />
        </ClientCacheProvider>
      </ODTeamBoundary>,
    );
  });
};

if (typeof requestIdleCallback === 'function') {
  requestIdleCallback(hydrate);
} else {
  // Safari doesn't support requestIdleCallback
  // https://caniuse.com/requestidlecallback
  setTimeout(hydrate, 1);
}
